import Image from "next/image";
import { TickSVGWhite } from "../components/svg";
import Link from "next/link";
import countryTaxes from "../data/tax-duties-data.json";
import { FOB_COUNTRIES } from "@/lib/calc-tax-duties";
import tax_bg from "/public/images/tax_bg.png";

export default function DutiesTaxesSegment({ isoCode, country }) {
  const countryData = countryTaxes[isoCode];
  const {
    currency,
    TAX_THRESHOLD_REC_CCY,
    TAX_RATES,
    DUTY_THRESHOLD_REC_CCY,
    DUTY_RATES,
  } = countryData;
  const hasDuties = Object.entries(DUTY_RATES).some(([_, value]) => {
    return value > 0;
  });
  const hasTaxes = TAX_RATES > 0;
  const isCIFCountry = !FOB_COUNTRIES.includes(isoCode);

  return (
    <div className="bg-slate-800 relative z-0">
      <div className="absolute inset-0 overflow-hidden z-[-1]">
        <Image
          src={tax_bg}
          alt="tax_bg"
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          className=""
        />
      </div>
      <div className="flex md:block flex-col items-center px-8 md:px-20 pt-16 pb-20 max-w-5xl mx-auto font-medium text-xl text-white">
        <p className="text-2xl">
          Will I get taxed by{" "}
          <span className="font-bold italic">
            <br />
            {country}
          </span>{" "}
          Customs?
        </p>
        {hasDuties ? (
          <div className="flex flex-col gap-y-4 md:gap-y-0 md:grid grid-cols-[40px_auto_5%_24%_20px_28%] mt-6 py-4 items-center text-center ">
            <p className="font-semibold text-2xl text-left">If</p>
            <div className="grid auto-rows-auto gap-y-2 font-normal">
              {isCIFCountry && (
                <>
                  <div className="bg-pink py-2">Insurance Cost</div>
                  <div className="bg-pink py-2">Shipping Cost</div>
                </>
              )}
              <div className="bg-pink py-2 px-2 md:px-1">
                Value of Item Shipped
              </div>
            </div>
            <p className="font-bold text-3xl md:text-2xl text-right">{">"}</p>
            <div className="pr-2">
              <p className="text-2xl font-semibold">
                {DUTY_THRESHOLD_REC_CCY} {currency}
              </p>
              <p className="text-xs font-light">DUTIES THRESHOLD</p>
            </div>
            <p className="font-semibold text-3xl">=</p>
            <div className="flex flex-col justify-center items-center px-4">
              <TickSVGWhite
                className="h-8 w-7"
                fill="#FD6C5F"
                strokeWidth="4.5"
              />
              <p className="text-base">Duties are incurred</p>
            </div>
          </div>
        ) : null}
        {hasTaxes ? (
          <div className="flex flex-col gap-y-4 md:gap-y-0 md:grid grid-cols-[40px_auto_5%_24%_20px_28%] mt-10 py-4 items-center text-center ">
            <p className="font-semibold text-2xl text-left">If</p>
            <div className="grid auto-rows-auto gap-y-2 font-normal text-black">
              {isCIFCountry && (
                <>
                  <div className="bg-yellow py-2">Insurance Cost</div>
                  <div className="bg-yellow py-2">Shipping Cost</div>
                </>
              )}
              <div className="bg-yellow py-2 px-2 md:px-1">
                Value of Item Shipped
              </div>
            </div>
            <p className="font-bold text-3xl md:text-2xl text-right">{">"}</p>
            <div className="px-2">
              <p className="text-2xl font-semibold">
                {TAX_THRESHOLD_REC_CCY} {currency}
              </p>
              <p className="text-xs font-light">TAXES THRESHOLD</p>
            </div>
            <p className="font-semibold text-3xl">=</p>
            <div className="flex flex-col justify-center items-center px-4">
              <TickSVGWhite
                className="h-8 w-7"
                fill="#FED430"
                strokeWidth="4.5"
              />
              <p className="text-base">Taxes are incurred</p>
            </div>
          </div>
        ) : null}
        {hasTaxes || hasDuties ? (
          <p className="text-center md:text-left mt-6">
            Calculate exact duties & taxes incurred on your shipment{" "}
            <br className="hidden md:block" /> in seconds with our{" "}
            <br className="md:hidden" />
            <Link href="/dashboard/get-a-quote">
              <span className="underline underline-offset-4 hover:cursor-pointer">
                duties & tax calculator.
              </span>
            </Link>
          </p>
        ) : (
          <p className="pt-8">There are no duties & taxes chargeable.</p>
        )}
      </div>
    </div>
  );
}
